import Adjustments from '../module/adjustments/en.locale';
import AI from '../module/ai/en.locale';
import Brush from '../module/brush/en.locale';
import CommonLocale from '../module/common/en.locale';
import Crop from '../module/crop/en.locale';
import Filters from '../module/filters/en.locale';
import Frames from '../module/frames/en.locale';
import Overlays from '../module/overlays/en.locale';
import Stickers from '../module/stickers/en.locale';
import Text from '../module/text/en.locale';
export default {
    'en-US': Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, CommonLocale), Adjustments), AI), Brush), Crop), Filters), Frames), Overlays), Stickers), Text),
};
